import ComposableContentModuleList, {
  ComposableContentModule,
} from '@/components/utilities/content-modules/composable-content-module-list/composable-content-module-list';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import styles from './composable-content.module.scss';

export interface ComposableContentProps extends ModuleWrapperProps {
  /** An array of the modules to show */
  contentModules: ComposableContentModule[];
}

const ComposableContent = ({
  contentModules,
  ...rest
}: ComposableContentProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <ComposableContentModuleList contentModules={contentModules} />
    </ModuleWrapper>
  );
};

ComposableContent.displayName = 'ComposableContent';

export default ComposableContent;
